import React from 'react';
import './AnswerReviewModal.css';

/** PHP #showmodel — EmptyFrame.png modal with centered answer lines */
export default function AnswerReviewModal({ title, lines, onConfirm }) {
  return (
    <div className="ic-answer-overlay">
      <div
        className="ic-answer-panel"
        style={{ '--ic-answer-frame': 'url(/img/EmptyFrame.png)' }}
      >
        <h3 className="ic-answer-title">{title}</h3>
        <div className="ic-answer-body">
          {lines.map((line, i) => (
            <p key={i} className="ic-answer-line">
              {line}
            </p>
          ))}
        </div>
        <div className="ic-answer-actions">
          <button type="button" className="ic-answer-btn" onClick={onConfirm}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
